import SwitchContainer from "../../../../Component/Forms/FormsWidgets/Switch/Switch"

const Switch = () => {
  return (
    <div className='page-body'>
      <SwitchContainer />
    </div>
  )
}

export default Switch